import { ReactElement } from 'react';
import { formatPhoneNumber } from 'lib/util';
import { IFragmentPhoneNumber } from 'types/contentful';

interface ContactCardsProps {
  items: IFragmentPhoneNumber[];
  className?: string;
}

const formatDisplayPhone = (phone: string): string => {
  const digitsOnly = phone.replace(/\D/g, '');

  if (digitsOnly.length === 10) {
    return formatPhoneNumber(digitsOnly);
  }

  return phone;
};

const toTelHref = (phone: string): string => `tel:${phone.replace(/\D/g, '')}`;

function LocationPinIcon(): ReactElement {
  return (
    <div className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
      >
        <path
          d="M12 21C12 21 18 15.75 18 10.5C18 7.18629 15.3137 4.5 12 4.5C8.68629 4.5 6 7.18629 6 10.5C6 15.75 12 21 12 21Z"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="12" cy="10.5" r="2.25" stroke="white" strokeWidth="2" />
      </svg>
    </div>
  );
}

export default function ContactCards({
  items,
  className = '',
}: ContactCardsProps): ReactElement | null {
  if (!items.length) {
    return null;
  }

  return (
    <div className={`${className} px-site-component`}>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {items.map((item) => (
          <div
            key={`${item.fields.contactName}-${item.fields.number}`}
            className="bg-neutral-alt px-5 py-5"
          >
            <div className="flex items-start gap-4">
              <LocationPinIcon />
              <div className="mt-1">
                <h3 className="font-heading text-lg text-primary-actual">
                  {item.fields.contactName}
                </h3>
                <a
                  href={toTelHref(item.fields.number)}
                  aria-label={`${item.fields.contactName} phone number`}
                  className="mt-2 inline-block underline text-secondary-actual text-lg"
                >
                  {formatDisplayPhone(item.fields.number)}
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
